import ErrorCodes from '../constants/ErrorCodes';

class CardWithoutAssigneesError extends Error {
    errorCode = ErrorCodes.CARD_WITHOUT_ASSIGNEES;

    constructor(card, ...args) {
        super(...args);

        this.card = card;
    }
}

export default {
    CardWithoutAssigneesError,
};
